


export default{
    data() {
        return {
            apis:{
                uploadUrl: this.$global.baseUrl + 'sh/file/upload',//文件上传路径
            },
            imageUrl:null,
        }
    },
    props:{
        files:{//已有图片列表
            type: Array,
            default:function(){
                return [];
            }
        },
        multi:{//是否多文件
            type: Boolean,
            default:false
        },
        maxSize:{//最大文件大小，单位：M
            type:Number,
            default:null
        },
        suffix:{//支持的文件后缀，多个之间用逗号分隔
            type:String,
            default:null
        }
    },
    mounted() {
        
    },
    methods: {
        uplodaSuccess(rsp, file) {
            const me = this;
            console.log(file);
            this.imageUrl = me.$global.baseUrl + rsp.retObj.path;
            console.log(me.imageUrl);
        },
        beforeUpload(file) {
            const me = this;
            let names = file.name.split('.');
            let fileSuffix = names.pop();
            console.log(fileSuffix)

            console.log(file);
            let size = me.maxSize ? file.size / 1024 / 1024 <= me.maxSize : true;
            let suffix = me.suffix ? me.suffix.indexOf(fileSuffix) > 0 : true;
            if (!suffix) {
                me.$message.error('上传文件后缀需满足[' + me.suffix + ']');
            }
            if (!size) {
                me.$message.error('上传文件不能超过' + me.maxSize + 'M');
            }
            return suffix && size;
        },
        removed(file, fileList){
            console.log(file, fileList);
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/upload/imgs/src/imgs.js